module.exports = __webpack_public_path__ + "static/media/Group78.bba55f0c.png";